module.exports = __webpack_public_path__ + "img/多类别接入方案.1b99da6f.png";